var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 169,
    viewBox: "0 0 276 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 276,
    height: 169,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2824_41406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.521 98.2914V71.709H162.035V77.8831H152.407V98.2914H145.521Z",
    fill: "#9B9FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.811 98.2914V87.8804H172.581V98.2914H165.695V71.709H172.581V81.6293H182.811V71.709H189.697V98.2914H182.811Z",
    fill: "#9B9FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.659 98.2914V77.8831H221.616V71.709H244.631V77.8831H236.549V98.2914H229.659Z",
    fill: "#9B9FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.483 98.2881V83.142L200.522 98.2881H194.764V71.7129H201.65V86.7014L212.427 71.7129H218.373V98.2881H211.483Z",
    fill: "#9B9FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.948 98.2914V82.4936L99.0727 90.8394L92.1975 82.4936V98.2914H85.3114V71.709H92.1074L99.0727 80.8493L106.038 71.709H112.834V98.2914H105.948Z",
    fill: "#9B9FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.906 88.9424H132.306L129.106 80.6076L125.906 88.9424ZM135.895 98.2878L134.454 94.5634H123.748L122.307 98.2878H115.385L125.975 71.709H132.342L142.936 98.2878H135.895Z",
    fill: "#9B9FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9922 77.1102C31.9989 73.8999 33.257 70.8229 35.4911 68.5532C37.7251 66.2834 40.7532 65.0058 43.9121 65H71.4312V71.1558H43.9194C42.3671 71.1625 40.8803 71.7919 39.7824 72.9071C38.6845 74.0221 38.0643 75.5328 38.0567 77.1102L38.0206 87.4444C37.895 88.7684 37.3415 90.0128 36.4464 90.9836C35.5513 91.9541 34.3652 92.596 33.0732 92.8093L31.9922 92.9777V77.1102Z",
    fill: "#9B9FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9941 105.001V98.8452H59.5131C61.0657 98.8376 62.5525 98.2073 63.6504 97.0917C64.7481 95.9759 65.3683 94.465 65.3758 92.8873V83.0804C65.3834 81.6576 65.8885 80.2839 66.8007 79.2046C67.7129 78.1252 68.9729 77.4106 70.3556 77.1882L71.4367 77.0234V92.8873C71.4299 96.098 70.172 99.1753 67.9379 101.446C65.704 103.716 62.6761 104.994 59.5167 105.001H31.9941Z",
    fill: "#9B9FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3061 92.9985V85.041L51.7171 89.3951L48.1318 85.041V92.9985H43.3789V77.3398H47.8795L51.7171 82.3751L55.5548 77.3398H60.0554V92.9985H55.3061Z",
    fill: "#9B9FB3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2824_41406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 212.632,
    height: 40,
    fill: "white",
    transform: "translate(32 65)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnit);
export default __webpack_public_path__ + "static/media/magnit.74ba18fc2a2fc1c45217c6e7611a60ff.svg";
export { ForwardRef as ReactComponent };